import React, { useCallback } from 'react';
import { Col, Form, Modal, Row, Select } from 'antd';
import { dspxGetChildrens } from '../../../../helpers/dspx-utils';
import { EditDocumentIcon } from '../../../../resource/icons';
import actions from '../../store/actions/edit-document.actions';
import { useDispatch } from 'react-redux';

const EditStatusModal = ({
  status,
  statusesList,
  getFieldDecorator,
  visible,
  onCancel,
  validateFields,
  prepareDataAndResetFields,
}) => {
  const dispatch = useDispatch();
  const subject = 'Статус';
  const subject_err = 'статус';

  const updateStatusOnOk = useCallback(() => {
    validateFields((err, values) => {
      if (err) return;
      const status = prepareDataAndResetFields(values);
      dispatch(actions.updateStatus(status.id, status.statusId));
      dispatch(actions.closeModal());
    });
  }, [validateFields]);

  return (
    <Modal
      style={{ minWidth: 400 }}
      width={500}
      visible={visible}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <EditDocumentIcon
            style={{
              height: 40,
              verticalAlign: 'middle',
              marginRight: 10,
            }}
          />
          <div>Статус</div>
        </div>
      }
      okText="Изменить"
      onCancel={onCancel}
      onOk={updateStatusOnOk}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col span={24}>
            <Form.Item label={subject}>
              {getFieldDecorator('statusId', {
                initialValue: status && status.id + '',
                rules: [
                  {
                    required: false,
                    message: 'Пожалуйста, укажите ' + subject_err,
                  },
                ],
              })(
                <Select
                  showSearch
                  placeholder="Статус"
                  notFoundContent="нет данных"
                  optionFilterProp="searchtext"
                >
                  {dspxGetChildrens(statusesList)}
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default EditStatusModal;
